import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_WATCH_LIST_ENTRY_BY_ID } from '../types';
import { getWatchListEntryByIdPending, getWatchListEntryByIdFulfilled, getWatchListEntryByIdRejected } from '../actions';
import { sendApiRequest, notifyError } from '../../../actions';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'watchlistentry/get',
  onSuccess: [getWatchListEntryByIdFulfilled],
  onError: [
    getWatchListEntryByIdRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getWatchListEntryByIdEpic$ = action$ => action$.pipe(
  ofType(GET_WATCH_LIST_ENTRY_BY_ID.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => merge(
    of(getWatchListEntryByIdPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default getWatchListEntryByIdEpic$;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/getWatchListEntryByIdEpic.js